import config from '../config';
import { fetchGuestToken } from './auth';
import { LEVIATHAN_LICENSE } from './games';

export const getTwitchUsernameForLeviathanStream = async (
    userID: string,
    token: string,
): Promise<string> => {
    const resp = await fetch(
        `${config.entityManagerURL}/entity-manager/game/${LEVIATHAN_LICENSE}/entities/game/SavedTwitchInfo_${userID}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'Get',
        },
    );

    if (resp.status !== 200) {
        console.error(await resp.text());
        return '';
    }

    const jsonBody = await resp.json();

    return jsonBody.data.data.TwitchInfo;
};

export const getGameEntity = async (
    license: string,
    entityName: string,
    token?: string,
): Promise<any> => {
    if (!token) {
        token = await fetchGuestToken();
    }

    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/entities/game/${entityName}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
        },
    );

    if (resp.status !== 200) {
        console.error(await resp.text());
        return undefined;
    }

    const jsonBody = await resp.json();
    return jsonBody.data;
};
